<template>
  <div v-if="userLevel < 0.50" id="customers">
    <form v-on:submit.prevent="processSearchAction(searchAction)">
      <div class="col-lg-12 row">
        <div class="col-lg-2">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="document-type" class="d-block text-center">{{t('searchLabelDocumentType','searchLabelDocumentType') }}</label>
              <select id="document-type" v-model="searchArrays.doc_type" class="form-control custom-select text-capitalize custom-select-overflow" multiple size="4">
                <option value="all">{{t('selectAll','selectAll') }}</option>
                <option v-for="documentType in documentTypes" :value="documentType.id" :key="documentType.id">{{ documentType.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="document-reference" class="d-block text-center">{{t(docSearch.label, docSearch.label) }}</label>
              <input id="document-reference" v-model="searchArrays.refRange" class="form-control text-center" :placeholder="t(docSearch.label,docSearch.label)" type="text">
            </div>
            <b-popover target="document-reference" triggers="hover" placement="top">
              <template v-slot:title>{{t(docSearch.popTitle, docSearch.popTitle)}}</template>
              <p>{{t(docSearch.popDef, docSearch.popDef)}}</p>
            </b-popover>
          </div>
          <div v-if="displaySettings.multipleDocumentsSearch">
            <div class="col-lg-12">
              <div class="form-group">
                <label for="multiple-refs" class="d-block text-center">{{ t(multipleDocSearch.label, multipleDocSearch.label) }}</label>
                <b-form-textarea
                    id="multiple-refs"
                    v-model="searchArrays.multiRefs"
                    :placeholder="t(multipleDocSearch.label, multipleDocSearch.label)"
                    rows="3"
                    max-rows="5"
                ></b-form-textarea>
              </div>
              <b-popover target="multiple-refs" triggers="hover" placement="bottom">
                <template v-slot:title>{{t(multipleDocSearch.popTitle, multipleDocSearch.popTitle)}}</template>
                <p>{{t(multipleDocSearch.popDef, multipleDocSearch.popDef)}}</p>
              </b-popover>
            </div>
            <div v-if="multipleDocSearch.exactSearch" class="col-lg-12">
              <div class="form-group">
                <b-form-checkbox v-model="documentsSearch.exact_search" type="checkbox" value="1" unchecked-value="0">
                  {{ t('searchLabelExactSearch', 'searchLabelExactSearch') }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="date-from" class="d-block text-center">{{t('searchLabelDocDateFrom','searchLabelDocDateFrom') }}</label>
              <datePicker id="date-from" v-model="documentsSearch.date_from" class="form-control text-center" :config="datePickerFromConfig" :placeholder="t('searchLabelDocDateFrom','searchLabelDocDateFrom')"></datePicker>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="date-to" class="d-block text-center">{{t('searchLabelDocDateTo','searchLabelDocDateTo') }}</label>
              <datePicker id="date-to" v-model="documentsSearch.date_to" class="form-control text-center" :config="datePickerToConfig" :placeholder="t('searchLabelDocDateTo','searchLabelDocDateTo')"></datePicker>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="customer-name" class="d-block text-center">{{t('searchLabelCustomerName','searchLabelCustomerName') }}</label>
              <input id="customer-name" v-model="documentsSearch.customer_name" class="form-control text-center" :placeholder="t('searchLabelCustomerName','searchLabelCustomerName')" type="text">
            </div>
          </div>
          <div v-if="!exactCustRefRequired" class="col-lg-12">
            <div class="form-group">
              <label for="customer-reference" class="d-block text-center">{{t('searchLabelCustomerRef','searchLabelCustomerRef') }}</label>
              <input id="customer-reference" v-model="searchArrays.customerRefs" class="form-control text-center" :placeholder="t('searchLabelCustomerRef','searchLabelCustomerRef')" type="text">
            </div>
            <b-popover target="customer-reference" triggers="hover" placement="bottom">
              <template v-slot:title>{{t('popTitleCustRef','popTitleCustRef')}}</template>
              <p>{{t('popDefCustRef', 'popDefCustRef')}}</p>
            </b-popover>
          </div>
          <div v-else class="col-lg-12">
            <span v-if="(clientName == 'tota')">
              <div v-if="userLevel >= 0.00" class="form-group">
                <label for="exact-customer-ref" class="d-block text-center">{{ t('searchLabelExactCustomerRef','searchLabelExactCustomerRef') }}</label>
                <input id="exact-customer-ref" v-model="searchArrays.customerRefs" class="form-control text-center" :placeholder="t('searchLabelExactCustomerRef','searchLabelExactCustomerRef')" type="text">
              </div>
            </span>
            <span v-else>
              <div class="form-group">
                <label for="exact-customer-ref" class="d-block text-center">{{ t('searchLabelExactCustomerRef','searchLabelExactCustomerRef') }}</label>
                <input id="exact-customer-ref" v-model="searchArrays.customerRefs" class="form-control text-center" :placeholder="t('searchLabelExactCustomerRef','searchLabelExactCustomerRef')" type="text">
              </div>
            </span>
          </div>
        </div>
        <div class="col-lg-2" v-if="['lous', 'loustest'].includes(clientName)">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="value-from" class="d-block text-center">{{t('searchLabelDocValueFrom','searchLabelDocValueFrom') }}</label>
              <input id="value-from" v-model="documentsSearch.value_from" class="form-control text-center" :placeholder="t('searchLabelDocValueFrom','searchLabelDocValueFrom')" type="number" step="0.01">
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="value-to" class="d-block text-center">{{t('searchLabelDocValueTo','searchLabelDocValueTo') }}</label>
              <input id="value-to" v-model="documentsSearch.value_to" class="form-control text-center" :placeholder="t('searchLabelDocValueTo','searchLabelDocValueTo')" type="number" step="0.01">
            </div>
          </div>
          <div class="col-lg-12" v-if="displayCurrency">
            <div class="form-group">
              <label for="currency" class="d-block text-center">{{t('searchLabelDocCurrency','searchLabelDocCurrency') }}</label>
              <input id="currency" v-model="searchArrays.currency" class="form-control text-center" :placeholder="t('searchLabelDocCurrency','searchLabelDocCurrency')" type="text">
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="vat_from" class="d-block text-center">{{t('searchLabelDocTaxFrom','searchLabelDocTaxFrom') }}</label>
              <input id="vat_from" v-model="documentsSearch.vat_from" class="form-control text-center" :placeholder="t('searchLabelDocTaxFrom','searchLabelDocTaxFrom')" type="number"  step="0.01">
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="vat-to" class="d-block text-center">{{t('searchLabelDocTaxTo','searchLabelDocTaxTo') }}</label>
              <input id="vat-to" v-model="documentsSearch.vat_to" class="form-control text-center" :placeholder="t('searchLabelDocTaxTo','searchLabelDocTaxTo')" type="number" step="0.01">
            </div>
          </div>
        </div>
        <div class="col-lg-2" v-if="['tota','totatest','client'].includes(clientName)">
          <!-- NS-9566:DL tota mpan search -->
          <div class="form-group">
            <label for="mprnGas" class="d-block text-center">MPRN (Gas) is</label>
            <input id="mprnGas" v-model="documentsSearch.mprnGas" class="form-control text-center" placeholder="MPRN" type="text">
          </div>
          <!--<b-popover target="client-data-1" triggers="hover" placement="bottom">
            <template v-slot:title>{{t('popTitleClientData1','popTitleClientData1')}}</template>
            <p>{{t('popDefClientData1', 'popDefClientData1')}}</p>
          </b-popover>-->
          <div class="form-group">
            <label for="mpanElec" class="d-block text-center">MPAN (Elec) is</label>
            <input id="mpanElec" v-model="documentsSearch.mpanElec" class="form-control text-center" placeholder="MPAN" type="text">
          </div>
          <!--<b-popover target="client-data-2" triggers="hover" placement="bottom">
            <template v-slot:title>{{t('popTitleClientData2','popTitleClientData2')}}</template>
            <p>{{t('popDefClientData2', 'popDefClientData2')}}</p>
          </b-popover>-->
          <div class="form-group">
            <label for="altPostcode" class="d-block text-center">Customer Supplied Postcode is</label>
            <input id="altPostcode" v-model="documentsSearch.altPostcode" class="form-control text-center" placeholder="Postcode" type="text">
          </div>
          <!--<b-popover target="client-data-2" triggers="hover" placement="bottom">
            <template v-slot:title>{{t('popTitleClientData2','popTitleClientData2')}}</template>
            <p>{{t('popDefClientData2', 'popDefClientData2')}}</p>
          </b-popover>-->
          <div class="form-group">
            <label for="client-data-1" class="d-block text-center">TGP Customer Reference is</label>
            <input id="client-data-1" v-model="documentsSearch.client_data_name_1" class="form-control text-center" placeholder="TGP Customer Reference" type="text">
          </div>
          <!--<b-popover target="client-data-1" triggers="hover" placement="bottom">
            <template v-slot:title>{{t('popTitleClientData1','popTitleClientData1')}}</template>
            <p>{{t('popDefClientData1', 'popDefClientData1')}}</p>
          </b-popover>-->
        </div>
        <div class="col-lg-2">
          <div v-if="clientDataName1 && (clientDataName1 != 'Aging')" class="col-lg-12">
            <div class="form-group">
              <label for="client-data-1" class="d-block text-center">{{ clientDataName1 }}</label>
              <input id="client-data-1" v-model="documentsSearch.client_data_name_1" class="form-control text-center" :placeholder="clientDataName1" type="text">
            </div>
            <b-popover target="client-data-1" triggers="hover" placement="bottom">
              <template v-slot:title>{{t('popTitleClientData1','popTitleClientData1')}}</template>
              <p>{{t('popDefClientData1', 'popDefClientData1')}}</p>
            </b-popover>
          </div>
          <div v-if="clientDataName2 && (clientDataName2 != 'Aging')" class="col-lg-12">
            <div class="form-group">
              <label for="client-data-2" class="d-block text-center">{{ clientDataName2 }}</label>
              <input id="client-data-2" v-model="documentsSearch.client_data_name_2" class="form-control text-center" :placeholder="clientDataName2" type="text">
            </div>
            <b-popover target="client-data-2" triggers="hover" placement="bottom">
              <template v-slot:title>{{t('popTitleClientData2','popTitleClientData2')}}</template>
              <p>{{t('popDefClientData2', 'popDefClientData2')}}</p>
            </b-popover>
          </div>
        </div>
      </div>
      <div v-if="clientSpecificFilters">
        <div class="mx-0 row justify-content-end">
          <b-button class="ml-4" v-b-toggle.extra-filters variant="primary">{{t('advancedFiltersButtonText','advancedFiltersButtonText')}}</b-button>
        </div>
        <b-collapse id="extra-filters" class="mt-2 ml-2 border">
          <div class="col-lg-12 row">
            <template v-for="(filterGroup, index) in clientSpecificFilters" >
              <div class="col-lg-2">
                <template v-for="(filter, index) in filterGroup">
                  <div class="form-group">
                    <label :for="'client-specific-' + index" class="d-block text-center">{{ t(filter.label, filter.label) }}</label>
                    <span v-if="filter.type == 'text'" :id="'client-specific-' + index">
                      <input v-model="searchArrays.extraFilters[index]" class="form-control text-center" :placeholder="t(filter.label, filter.label)" type="text">
                    </span>
                    <span v-if="filter.type == 'select'" :id="'client-specific-' + index">
                      <select v-model="searchArrays.extraFilters[index]" class="form-control custom-select text-capitalize">
                        <!--<option :value="''" selected>{{t('selectAll','selectAll') }}</option>-->
                        <option v-for="(option, key) in filter.value" :value="key" :key="key">{{ t(option, option) }}</option>
                      </select>
                    </span>
                    <span v-if="filter.type == 'datepicker'" :id="'client-specific-' + index">
                      <datePicker v-model="searchArrays.extraFilters[index]" class="form-control text-center" :config="datePickerDefaultConfig" :placeholder="t(filter.label, filter.label)"></datePicker>
                    </span>
                    <span v-if="filter.type == 'checkbox'" :id="'client-specific-' + index">
                      <b-form-checkbox v-model="searchArrays.extraFilters[index]" type="checkbox" value="1" unchecked-value="0">
                        {{ t(filter.placeholder, filter.placeholder) }}
                      </b-form-checkbox>
                    </span>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </b-collapse>
      </div>
      <div class="row justify-content-between pt-3">
        <div class="col-lg-2">
          <b-input-group class="col-lg-12">
            <b-input-group-prepend>
              <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
            </b-input-group-prepend>
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-input-group>
        </div>
        <div class="col-lg-4 text-center align-self-center mr-2">
          <button v-if="!isLoading" class="btn btn-primary float-lg-right float-sm-none center-btn ml-2" type="submit" @click="disableInfinityScroll">{{ t('searchButtonText','searchButtonText') }}</button>
          <b-button v-if="isLoading" class="float-lg-right float-sm-none ml-2" variant="primary" disabled>
            <b-spinner small type="grow"></b-spinner>
             {{ t('searchButtonText','searchButtonText') }}
          </b-button>
        </div>
      </div>
    </form>
  </div>
  <div v-else-if="userLevel == 0.50" id="staff">
    <form v-on:submit.prevent="processSearchAction(searchAction)">
      <div class="col-lg-12 row">
        <div class="col-lg-2">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="document-type" class="d-block text-center">{{t('searchLabelDocumentType','searchLabelDocumentType') }}</label>
              <select id="document-type" v-model="searchArrays.doc_type" class="form-control custom-select text-capitalize custom-select-overflow" multiple size="4">
                <option value="all" selected>{{t('selectAll','selectAll') }}</option>
                <option v-for="documentType in documentTypes" :value="documentType.id" :key="documentType.id">{{ documentType.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="document-reference" class="d-block text-center">{{t(docSearch.label, docSearch.label) }}</label>
              <input id="document-reference" v-model="searchArrays.refRange" class="form-control text-center" :placeholder="t(docSearch.label, docSearch.label)" type="text">
            </div>
            <b-popover target="document-reference" triggers="hover" placement="bottom">
              <template v-slot:title>{{t(docSearch.popTitle,docSearch.popTitle)}}</template>
              <p>{{t(docSearch.popDef, docSearch.popDef)}}</p>
            </b-popover>
          </div>
          <div v-if="displaySettings.multipleDocumentsSearch">
            <div class="col-lg-12">
              <div class="form-group">
                <label for="multiple-refs" class="d-block text-center">{{ t(multipleDocSearch.label, multipleDocSearch.label) }}</label>
                <b-form-textarea
                    id="multiple-refs"
                    v-model="searchArrays.multiRefs"
                    :placeholder="t(multipleDocSearch.label, multipleDocSearch.label)"
                    rows="3"
                    max-rows="5"
                ></b-form-textarea>
              </div>
              <b-popover target="multiple-refs" triggers="hover" placement="bottom">
                <template v-slot:title>{{t(multipleDocSearch.popTitle, multipleDocSearch.popTitle)}}</template>
                <p>{{t(multipleDocSearch.popDef, multipleDocSearch.popDef)}}</p>
              </b-popover>
            </div>
          </div>
          <div v-if="multipleDocSearch.exactSearch" class="col-lg-12">
            <div class="form-group">
              <b-form-checkbox v-model="documentsSearch.exact_search" type="checkbox" value="1" unchecked-value="0">
                {{ t('searchLabelExactSearch', 'searchLabelExactSearch') }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="date-from" class="d-block text-center">{{t('searchLabelDocDateFrom','searchLabelDocDateFrom') }}</label>
              <datePicker id="date-from" v-model="documentsSearch.date_from" class="form-control text-center" :config="datePickerFromConfig" :placeholder="t('searchLabelDocDateFrom','searchLabelDocDateFrom')"></datePicker>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="date-to" class="d-block text-center">{{t('searchLabelDocDateTo','searchLabelDocDateTo') }}</label>
              <datePicker id="date-to" v-model="documentsSearch.date_to" class="form-control text-center" :config="datePickerToConfig" :placeholder="t('searchLabelDocDateTo','searchLabelDocDateTo')"></datePicker>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="customer-name" class="d-block text-center">{{t('searchLabelCustomerName','searchLabelCustomerName') }}</label>
              <input id="customer-name" v-model="documentsSearch.customer_name" class="form-control text-center" :placeholder="t('searchLabelCustomerName','searchLabelCustomerName')" type="text">
            </div>
          </div>
          <div v-if="!exactCustRefRequired" class="col-lg-12">
            <div class="form-group">
              <label for="customer-reference" class="d-block text-center">{{t('searchLabelCustomerRef','searchLabelCustomerRef') }}</label>
              <input id="customer-reference" v-model="searchArrays.customerRefs" class="form-control text-center" :placeholder="t('searchLabelCustomerRef','searchLabelCustomerRef')" type="text">
            </div>
            <b-popover target="customer-reference" triggers="hover" placement="bottom">
              <template v-slot:title>{{t('popTitleCustRef','popTitleCustRef')}}</template>
              <p>{{t('popDefCustRef', 'popDefCustRef')}}</p>
            </b-popover>
          </div>
          <div v-else class="col-lg-12">
            <span v-if="(clientName == 'tota')">
              <div v-if="userLevel >= 0.00" class="form-group">
                <label for="exact-customer-ref" class="d-block text-center">{{ t('searchLabelExactCustomerRef','searchLabelExactCustomerRef') }}</label>
                <input id="exact-customer-ref" v-model="searchArrays.customerRefs" class="form-control text-center" :placeholder="t('searchLabelExactCustomerRef','searchLabelExactCustomerRef')" type="text">
              </div>
            </span>
            <span v-else>
              <div class="form-group">
                <label for="exact-customer-ref" class="d-block text-center">{{ t('searchLabelExactCustomerRef','searchLabelExactCustomerRef') }}</label>
                <input id="exact-customer-ref" v-model="searchArrays.customerRefs" class="form-control text-center" :placeholder="t('searchLabelExactCustomerRef','searchLabelExactCustomerRef')" type="text">
              </div>
            </span>
          </div>
        </div>
        <div class="col-lg-2">
          <div v-if="clientDataName1 && (clientDataName1 != 'Aging')" class="col-lg-12">
            <div class="form-group">
              <label for="client-data-1" class="d-block text-center">{{ clientDataName1 }}</label>
              <input id="client-data-1" v-model="documentsSearch.client_data_name_1" class="form-control text-center" :placeholder="clientDataName1" type="text">
            </div>
            <b-popover target="client-data-1" triggers="hover" placement="bottom">
              <template v-slot:title>{{t('popTitleClientData1','popTitleClientData1')}}</template>
              <p>{{t('popDefClientData1', 'popDefClientData1')}}</p>
            </b-popover>
          </div>
          <div v-if="clientDataName2 && (clientDataName2 != 'Aging')" class="col-lg-12">
            <div class="form-group">
              <label for="client-data-2" class="d-block text-center">{{ clientDataName2 }}</label>
              <input id="client-data-2" v-model="documentsSearch.client_data_name_2" class="form-control text-center" :placeholder="clientDataName2" type="text">
            </div>
            <b-popover target="client-data-2" triggers="hover" placement="bottom">
              <template v-slot:title>{{t('popTitleClientData2','popTitleClientData2')}}</template>
              <p>{{t('popDefClientData2', 'popDefClientData2')}}</p>
            </b-popover>
          </div>
        </div>
        <div class="col-lg-2" v-if="['lous', 'loustest'].includes(clientName)">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="value-from" class="d-block text-center">{{t('searchLabelDocValueFrom','searchLabelDocValueFrom') }}</label>
              <input id="value-from" v-model="documentsSearch.value_from" class="form-control text-center" :placeholder="t('searchLabelDocValueFrom','searchLabelDocValueFrom')" type="number" step="0.01">
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="value-to" class="d-block text-center">{{t('searchLabelDocValueTo','searchLabelDocValueTo') }}</label>
              <input id="value-to" v-model="documentsSearch.value_to" class="form-control text-center" :placeholder="t('searchLabelDocValueTo','searchLabelDocValueTo')" type="number" step="0.01">
            </div>
          </div>
          <div class="col-lg-12" v-if="displayCurrency">
            <div class="form-group">
              <label for="currency" class="d-block text-center">{{t('searchLabelDocCurrency','searchLabelDocCurrency') }}</label>
              <input id="currency" v-model="searchArrays.currency" class="form-control text-center" :placeholder="t('searchLabelDocCurrency','searchLabelDocCurrency')" type="text">
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="vat_from" class="d-block text-center">{{t('searchLabelDocTaxFrom','searchLabelDocTaxFrom') }}</label>
              <input id="vat_from" v-model="documentsSearch.vat_from" class="form-control text-center" :placeholder="t('searchLabelDocTaxFrom','searchLabelDocTaxFrom')" type="number" step="0.01">
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="vat-to" class="d-block text-center">{{t('searchLabelDocTaxTo','searchLabelDocTaxTo') }}</label>
              <input id="vat-to" v-model="documentsSearch.vat_to" class="form-control text-center" :placeholder="t('searchLabelDocTaxTo','searchLabelDocTaxTo')" type="number" step="0.01">
            </div>
          </div>
        </div>
      </div>
      <div v-if="clientSpecificFilters">
        <div class="mx-0 row justify-content-end">
          <b-button class="ml-4" v-b-toggle.extra-filters variant="primary">{{t('advancedFiltersButtonText','advancedFiltersButtonText')}}</b-button>
        </div>
        <b-collapse id="extra-filters" class="mt-2 ml-2 border">
          <div class="col-lg-12 row">
            <template v-for="(filterGroup, index) in clientSpecificFilters" >
              <div class="col-lg-2">
                <template v-for="(filter, index) in filterGroup">
                  <div class="form-group">
                    <label :for="'client-specific-' + index" class="d-block text-center">{{ t(filter.label, filter.label) }}</label>
                    <span v-if="filter.type == 'text'" :id="'client-specific-' + index">
                      <input v-model="searchArrays.extraFilters[index]" class="form-control text-center" :placeholder="t(filter.label, filter.label)" type="text">
                    </span>
                    <span v-if="filter.type == 'select'" :id="'client-specific-' + index">
                      <select v-model="searchArrays.extraFilters[index]" class="form-control custom-select text-capitalize">
                        <!--<option :value="''" selected>{{t('selectAll','selectAll') }}</option>-->
                        <option v-for="(option, key) in filter.value" :value="key" :key="key">{{ t(option, option) }}</option>
                      </select>
                    </span>
                    <span v-if="filter.type == 'datepicker'" :id="'client-specific-' + index">
                      <datePicker v-model="searchArrays.extraFilters[index]" class="form-control text-center" :config="datePickerDefaultConfig" :placeholder="t(filter.label, filter.label)"></datePicker>
                    </span>
                    <span v-if="filter.type == 'checkbox'" :id="'client-specific-' + index">
                      <b-form-checkbox v-model="searchArrays.extraFilters[index]" type="checkbox" value="1" unchecked-value="0">
                        {{ t(filter.placeholder, filter.placeholder) }}
                      </b-form-checkbox>
                    </span>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </b-collapse>
      </div>
      <div class="row justify-content-between pt-3">
        <div class="col-lg-2">
          <b-input-group class="col-lg-12">
            <b-input-group-prepend>
              <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
            </b-input-group-prepend>
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-input-group>
        </div>
        <div class="col-lg-4 text-center align-self-center">
          <button v-if="!isLoading" class="btn btn-primary float-lg-right float-sm-none ml-2" type="submit" @click="disableInfinityScroll">{{ t('searchButtonText','searchButtonText') }}</button>
          <b-button v-if="isLoading" class="float-lg-right float-sm-none ml-2" variant="primary" disabled>
            <b-spinner small type="grow"></b-spinner>
             {{ t('searchButtonText','searchButtonText') }}
          </b-button>
        </div>
      </div>
    </form>
  </div>
  <div v-else id="cc-and-above">
    <form v-on:submit.prevent="processSearchAction(searchAction)">
      <div class="col-lg-12 row">
        <div class="col-lg-2">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="document-type" class="d-block text-center">{{t('searchLabelDocumentType','searchLabelDocumentType') }}</label>
              <select id="document-type" v-model="searchArrays.doc_type" class="form-control custom-select text-capitalize custom-select-overflow" multiple size="4">
                <option value="all" selected>{{t('selectAll','selectAll') }}</option>
                <option v-for="documentType in documentTypes" :value="documentType.id" :key="documentType.id">{{ documentType.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="document-reference" class="d-block text-center">{{t(docSearch.label, docSearch.label) }}</label>
              <input id="document-reference" v-model="searchArrays.refRange" class="form-control text-center" :placeholder="t(docSearch.label, docSearch.label)" type="text">
            </div>
            <b-popover target="document-reference" triggers="hover" placement="bottom">
              <template v-slot:title>{{t(docSearch.popTitle,docSearch.popTitle)}}</template>
              <p>{{t(docSearch.popDef, docSearch.popDef)}}</p>
            </b-popover>
          </div>
          <div v-if="displaySettings.multipleDocumentsSearch">
            <div class="col-lg-12">
              <div class="form-group">
                <label for="multiple-refs" class="d-block text-center">{{ t(multipleDocSearch.label, multipleDocSearch.label) }}</label>
                <b-form-textarea
                    id="multiple-refs"
                    v-model="searchArrays.multiRefs"
                    :placeholder="t(multipleDocSearch.label, multipleDocSearch.label)"
                    rows="3"
                    max-rows="5"
                ></b-form-textarea>
              </div>
              <b-popover target="multiple-refs" triggers="hover" placement="bottom">
                <template v-slot:title>{{t(multipleDocSearch.popTitle, multipleDocSearch.popTitle)}}</template>
                <p>{{t(multipleDocSearch.popDef, multipleDocSearch.popDef)}}</p>
              </b-popover>
            </div>
            <div v-if="multipleDocSearch.exactSearch" class="col-lg-12">
              <div class="form-group">
                <b-form-checkbox v-model="documentsSearch.exact_search" type="checkbox" value="1" unchecked-value="0">
                  {{ t('searchLabelExactSearch', 'searchLabelExactSearch') }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
          <div v-if="(Number(userLevel) > 0.50)" class="col-lg-12">
            <div class="form-group">
              <label for="document-pages" class="d-block text-center">{{t('searchLabelDocNumOfPages','searchLabelDocNumOfPages') }}</label>
              <input id="document-pages" v-model="documentsSearch.doc_pages" class="form-control text-center" :placeholder="t('searchLabelDocNumOfPages','searchLabelDocNumOfPages')" type="text">
            </div>
          </div>
          <div v-if="userLevel == 3.00" class="col-lg-12">
            <div class="form-group">
              <label for="document-code" class="d-block text-center">{{t('searchLabelDocCode','searchLabelDocCode') }}</label>
              <input id="document-code" v-model="searchArrays.docIds" class="form-control text-center" :placeholder="t('searchLabelDocCode','searchLabelDocCode')" type="text">
            </div>
            <b-popover target="document-code" triggers="hover" placement="top">
              <template v-slot:title>{{t('popTitleDocCode','popTitleDocCode')}}</template>
              <p>{{t('popDefDocCode', 'popDefDocCode')}}</p>
            </b-popover>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="date-from" class="d-block text-center">{{t('searchLabelDocDateFrom','searchLabelDocDateFrom') }}</label>
              <datePicker id="date-from" v-model="documentsSearch.date_from" class="form-control text-center" :config="datePickerFromConfig" :placeholder="t('searchLabelDocDateFrom','searchLabelDocDateFrom')"></datePicker>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="date-to" class="d-block text-center">{{t('searchLabelDocDateTo','searchLabelDocDateTo') }}</label>
              <datePicker id="date-to" v-model="documentsSearch.date_to" class="form-control text-center" :config="datePickerToConfig" :placeholder="t('searchLabelDocDateTo','searchLabelDocDateTo')"></datePicker>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="customer-name" class="d-block text-center">{{t('searchLabelCustomerName','searchLabelCustomerName') }}</label>
              <input id="customer-name" v-model="documentsSearch.customer_name" class="form-control text-center" :placeholder="t('searchLabelCustomerName','searchLabelCustomerName')" type="text">
            </div>
          </div>
          <div v-if="!exactCustRefRequired" class="col-lg-12">
            <div class="form-group">
              <label for="customer-reference" class="d-block text-center">{{t('searchLabelCustomerRef','searchLabelCustomerRef') }}</label>
              <input id="customer-reference" v-model="searchArrays.customerRefs" class="form-control text-center" :placeholder="t('searchLabelCustomerRef','searchLabelCustomerRef')" type="text">
            </div>
            <b-popover target="customer-reference" triggers="hover" placement="bottom">
              <template v-slot:title>{{t('popTitleCustRef','popTitleCustRef')}}</template>
              <p>{{t('popDefCustRef', 'popDefCustRef')}}</p>
            </b-popover>
          </div>
          <div v-else class="col-lg-12">
            <span v-if="(clientName == 'tota')">
              <div v-if="userLevel >= 0.00" class="form-group">
                <label for="exact-customer-ref" class="d-block text-center">{{ t('searchLabelExactCustomerRef','searchLabelExactCustomerRef') }}</label>
                <input id="exact-customer-ref" v-model="searchArrays.customerRefs" class="form-control text-center" :placeholder="t('searchLabelExactCustomerRef','searchLabelExactCustomerRef')" type="text">
              </div>
            </span>
            <span v-else>
              <div class="form-group">
                <label for="exact-customer-ref" class="d-block text-center">{{ t('searchLabelExactCustomerRef','searchLabelExactCustomerRef') }}</label>
                <input id="exact-customer-ref" v-model="searchArrays.customerRefs" class="form-control text-center" :placeholder="t('searchLabelExactCustomerRef','searchLabelExactCustomerRef')" type="text">
              </div>
            </span>
          </div>
        </div>
        <div class="col-lg-2" v-if="['lous', 'loustest'].includes(clientName)">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="value-from" class="d-block text-center">{{t('searchLabelDocValueFrom','searchLabelDocValueFrom') }}</label>
              <input id="value-from" v-model="documentsSearch.value_from" class="form-control text-center" :placeholder="t('searchLabelDocValueFrom','searchLabelDocValueFrom')" type="number" step="0.01">
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="value-to" class="d-block text-center">{{t('searchLabelDocValueTo','searchLabelDocValueTo') }}</label>
              <input id="value-to" v-model="documentsSearch.value_to" class="form-control text-center" :placeholder="t('searchLabelDocValueTo','searchLabelDocValueTo')" type="number" step="0.01">
            </div>
          </div>
          <div class="col-lg-12" v-if="displayCurrency">
            <div class="form-group">
              <label for="currency" class="d-block text-center">{{t('searchLabelDocCurrency','searchLabelDocCurrency') }}</label>
              <input id="currency" v-model="searchArrays.currency" class="form-control text-center" :placeholder="t('searchLabelDocCurrency','searchLabelDocCurrency')" type="text">
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="vat_from" class="d-block text-center">{{t('searchLabelDocTaxFrom','searchLabelDocTaxFrom') }}</label>
              <input id="vat_from" v-model="documentsSearch.vat_from" class="form-control text-center" :placeholder="t('searchLabelDocTaxFrom','searchLabelDocTaxFrom')" type="number" step="0.01">
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <label for="vat-to" class="d-block text-center">{{t('searchLabelDocTaxTo','searchLabelDocTaxTo') }}</label>
              <input id="vat-to" v-model="documentsSearch.vat_to" class="form-control text-center" :placeholder="t('searchLabelDocTaxTo','searchLabelDocTaxTo')" type="number" step="0.01">
            </div>
          </div>
          <div class="col-lg-12" v-if="userLevel == 3.00">
            <div class="form-group">
              <label for="post-house" class="d-block text-center">{{t('searchLabelDocPostHouse','searchLabelDocPostHouse') }}</label>
              <input id="post-house" v-model="searchArrays.post_house" class="form-control text-center" :placeholder="t('searchLabelDocPostHouse','searchLabelDocPostHouse')" type="text">
            </div>
          </div>
        </div>
        <div class="col-lg-2" v-if="['tota', 'totatest', 'client'].includes(clientName)">
          <!-- NS-9566:DL tota mpan search -->
          <div class="form-group">
            <label for="mprnGas" class="d-block text-center">MPRN (Gas) is</label>
            <input id="mprnGas" v-model="documentsSearch.mprnGas" class="form-control text-center" placeholder="MPRN" type="text">
          </div>
          <!--<b-popover target="client-data-1" triggers="hover" placement="bottom">
            <template v-slot:title>{{t('popTitleClientData1','popTitleClientData1')}}</template>
            <p>{{t('popDefClientData1', 'popDefClientData1')}}</p>
          </b-popover>-->
          <div class="form-group">
            <label for="mpanElec" class="d-block text-center">MPAN (Elec) is</label>
            <input id="mpanElec" v-model="documentsSearch.mpanElec" class="form-control text-center" placeholder="MPAN" type="text">
          </div>
          <!--<b-popover target="client-data-2" triggers="hover" placement="bottom">
            <template v-slot:title>{{t('popTitleClientData2','popTitleClientData2')}}</template>
            <p>{{t('popDefClientData2', 'popDefClientData2')}}</p>
          </b-popover>-->
          <div class="form-group">
            <label for="altPostcode" class="d-block text-center">Customer Supplied Postcode is</label>
            <input id="altPostcode" v-model="documentsSearch.altPostcode" class="form-control text-center" placeholder="Postcode" type="text">
          </div>
          <!--<b-popover target="client-data-2" triggers="hover" placement="bottom">
            <template v-slot:title>{{t('popTitleClientData2','popTitleClientData2')}}</template>
            <p>{{t('popDefClientData2', 'popDefClientData2')}}</p>
          </b-popover>-->
          <div class="form-group">
            <label for="client-data-1" class="d-block text-center">TGP Customer Reference is</label>
            <input id="client-data-1" v-model="documentsSearch.client_data_name_1" class="form-control text-center" placeholder="TGP Customer Reference" type="text">
          </div>
          <!--<b-popover target="client-data-1" triggers="hover" placement="bottom">
            <template v-slot:title>{{t('popTitleClientData1','popTitleClientData1')}}</template>
            <p>{{t('popDefClientData1', 'popDefClientData1')}}</p>
          </b-popover>-->
        </div>
        <div class="col-lg-2">
          <div v-if="(proof === 'approved')" class="col-lg-12">
            <div v-if="!multiBatchSearch">
              <div class="form-group">
                <label for="batch-id" class="d-block text-center">{{ t('searchLabelBatchesAre','searchLabelBatchesAre') }}</label>
                <input id="batch-id" v-model="searchArrays.batches" class="form-control text-center" :placeholder="t('searchLabelBatchesAre','searchLabelBatchesAre')" type="text">
              </div>
            </div>
            <div v-else>
              <label for="batch-id" class="d-block text-center">{{ t('searchLabelBatchesAre','searchLabelBatchesAre') }}</label>
              <select id="batch-id" v-model="searchArrays.batches" class="form-control custom-select text-capitalize custom-select-overflow" multiple size="4">
                <option :value="undefined" selected>{{t('selectAll', 'selectAll')}}</option>
                <option v-for="batch in batchOptions" :value="batch.id" :key="batch.id">{{ `(${ (batch.parent_batch != 0) ? batch.parent_batch + ' - ' + batch.id :  batch.id}) ${batch.reference}` }}</option>
              </select>
            </div>
          </div>
          <div v-if="Number(userLevel) >= 1.5 && proof === 'approved'" class="col-lg-12">
            <div class="form-group">
              <label for="batch-status" class="d-block text-center">{{ t('searchLabelBatchStatus') }}</label>
              <select id="batch-status" v-model="documentsSearch.batch_status" class="form-control custom-select text-capitalize">
                <option :value="'all'" selected>{{t('selectAll','selectAll') }}</option>
                <option :value="'approved'">{{t('optionApproved','optionApproved') }}</option>
                <option :value="'proof'">{{t('optionUnapproved','optionUnapproved') }}</option>
                <option :value="'rejected'">{{t('optionRejected','optionRejected') }}</option>
              </select>
            </div>
          </div>
          <div v-if="clientDataName1 && (clientDataName1 != 'Aging')" class="col-lg-12">
            <div class="form-group">
              <label for="client-data-1" class="d-block text-center">{{ clientDataName1 }}</label>
              <input id="client-data-1" v-model="searchArrays.clientData1" class="form-control text-center" :placeholder="clientDataName1" type="text">
            </div>
            <b-popover target="client-data-1" triggers="hover" placement="bottom">
              <template v-slot:title>{{t('popTitleClientData1','popTitleClientData1')}}</template>
              <p>{{t('popDefClientData1', 'popDefClientData1')}}</p>
            </b-popover>
          </div>
          <div v-if="clientDataName2 && (clientDataName2 != 'Aging')" class="col-lg-12">
            <div class="form-group">
              <label for="client-data-2" class="d-block text-center">{{ clientDataName2 }}</label>
              <input id="client-data-2" v-model="searchArrays.clientData2" class="form-control text-center" :placeholder="clientDataName2" type="text">
            </div>
            <b-popover target="client-data-2" triggers="hover" placement="bottom">
              <template v-slot:title>{{t('popTitleClientData2','popTitleClientData2')}}</template>
              <p>{{t('popDefClientData2', 'popDefClientData2')}}</p>
            </b-popover>
          </div>
        </div>
        <div v-if="clientSpecificFilters" class="col-lg-2">
          <div v-for="(filterGroup, index) in clientSpecificFilters" class="col-lg-12">
            <template v-for="(filter, index) in filterGroup">
              <div class="form-group">
                <label :for="'client-specific-' + index" class="d-block text-center">{{ t(filter.label, filter.label) }}</label>
                <span v-if="filter.type == 'text'" :id="'client-specific-' + index">
                  <input v-model="searchArrays.extraFilters[index]" class="form-control text-center" :placeholder="t(filter.label, filter.label)" type="text">
                </span>
                <span v-if="filter.type == 'select'" :id="'client-specific-' + index">
                  <select v-model="searchArrays.extraFilters[index]" class="form-control custom-select text-capitalize">
                    <option v-for="(option, key) in filter.value" :value="key" :key="key">{{ t(option, option) }}</option>
                  </select>
                </span>
                <span v-if="filter.type == 'datepicker'" :id="'client-specific-' + index">
                  <datePicker v-model="searchArrays.extraFilters[index]" class="form-control text-center" :config="datePickerDefaultConfig" :placeholder="t(filter.label, filter.label)"></datePicker>
                </span>
                <span v-if="filter.type == 'checkbox'" :id="'client-specific-' + index">
                  <b-form-checkbox v-model="searchArrays.extraFilters[index]" type="checkbox" value="1" unchecked-value="0">
                    {{ t(filter.placeholder, filter.placeholder) }}
                  </b-form-checkbox>
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- EIPP-802 Moved advanced filters to main search box, PW -->
      <!--<div v-if="clientSpecificFilters">
        <div class="mx-0 row justify-content-end">
          <b-button class="ml-4" v-b-toggle.extra-filters variant="primary">{{t('advancedFiltersButtonText','advancedFiltersButtonText')}}</b-button>
        </div>
        <b-collapse id="extra-filters" class="mt-2 ml-2 border">
          
        </b-collapse>
      </div>-->
      <div class="row justify-content-between pt-3">
        <div class="col-lg-2 px-0">
          <b-input-group class="col-lg-12">
            <b-input-group-prepend>
              <label class="input-group-text">{{ t('paginationPerPage','paginationPerPage') }}</label>
            </b-input-group-prepend>
            <b-form-select v-model="documentsSearch.per_page" :options="pageOptions"></b-form-select>
          </b-input-group>
        </div>
        <div class="col-lg-4 text-center align-self-center pt-3 px-0">
          <b-input-group class="col-lg-12">
            <b-input-group-prepend>
              <label class="input-group-text">{{ t('searchSelectText','searchSelectText') }}</label>
            </b-input-group-prepend>
            <b-form-select v-model="searchAction">
              <option value="list_documents_per_page" selected>{{t('listDocumentsPerPage', 'listDocumentsPerPage')}}</option>
              <option value="list_all_documents">{{t('listAllDocuments', 'listAllDocuments')}}</option>
              <option v-if="(displaySettings.selViewReq == 1) || (Number(userLevel) >= 2.00)" value="download-sumcsv">{{ t('documentToolsDownloadDocsSumCSV','documentToolsDownloadDocsSumCSV') }}</option>
            </b-form-select>
            <b-input-group-append>
              <b-button v-if="!isLoading" variant="primary" type="submit" @click="disableInfinityScroll">{{ t('searchButtonText','searchButtonText') }}</b-button>
              <b-button v-if="isLoading" variant="primary" disabled>
                <b-spinner small type="grow"></b-spinner>
                {{ t('searchButtonText','searchButtonText') }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import datePicker from 'vue-bootstrap-datetimepicker'

export default {
  name: 'SearchBar',
  //this component inherits from the Search.vue component
  inject: [
    'proof',
    'searchArrays',
    'resetModal',
    'userLevel',
    'clientName',
    'documentsSearch',
    'pageOptions',
    'perPage',
    'searchDocuments',
    'datePickerFormat',
  ],
  data () {
    return {
      datePickerFromConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        showClear: true
      },
      datePickerToConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        minDate: moment(new Date('1979-01-01'), this.datePickerFormat),
        showClear: true
      },
      datePickerDefaultConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        minDate: moment(new Date('1979-01-01'), this.datePickerFormat),
        showClear: true
      },
      docSearch:{
        label: 'searchLabelDocRef',
        popTitle: 'popTitleDocRef',
        popDef: 'popDefDocRef',
      },
      multipleDocSearch: {
        label: 'searchLabelMultipleDocRefsAre',
        popTitle: 'popTitleMultiRef',
        popDef: 'popDefMultiRef',
        exactSearch: false
      },
      multiBatchSearch: false,
      searchAction: 'list_documents_per_page',
    }
  },
  computed:{
    /*
    proof() {
      if(this.proof){
        return true
      } else {
        return false
      }
    },*/
    clientDataName1() {
      return this.$store.getters.allTemplateDetails.client_data_1_name
    },
    clientDataName2() {
      return this.$store.getters.allTemplateDetails.client_data_2_name
    },
    clientSpecificFilters() {
      return this.$store.getters['documentsStore/getClientSpecificFilters']
    },
    batchOptions() {
      return this.$store.getters['documentsStore/getBatchOptions']
    },
    documentTypes() {
      return this.$store.getters['documentsStore/getDocumentTypes']
    },
    exactCustRefRequired() {
      if(this.$route.query.exact_customer_ref || (this.clientName === 'brew') || (this.clientName === 'tota') || (this.clientName === 'trav') ) {
        return true
      } else {
        return false
      }
    },
    displaySettings: {
      get() {
        return this.$store.getters['documentsStore/getDisplaySettings']
      },
      set(newDisplaySettings) {
        this.$store.commit('documentsStore/setDisplaySettings', newDisplaySettings)
      }
    },
    displayCurrency: {
      get() {
        return (this.displaySettings.displayCurrency) ? true : false
      }
    },
    date_from() {
      return this.documentsSearch.date_from
    },
    isLoading() {
      return this.$attrs.isLoading
    }
  },
  watch: {
    date_from(date) {
      if(date) {
        let dateFrom = moment(date, this.datePickerFormat)
        this.datePickerToConfig.minDate = dateFrom
      } else {
        this.datePickerToConfig.minDate = moment(new Date('1979-01-01'), this.datePickerFormat)
      }
    }
  },
  methods: {
    disableInfinityScroll() {
      this.$parent.$parent.resetInfiniteScroll()
    },
    processSearchAction(searchAction) {
      this.$emit('search', searchAction)
    },
  },
  created() {
    //datepicker setup
    this.datePickerFromConfig.format = this.datePickerFormat
    this.datePickerToConfig.format = this.datePickerFormat
    this.datePickerDefaultConfig.format = this.datePickerFormat
    let todaysDate = moment(new Date(), this.datePickerFormat)
    this.datePickerFromConfig.maxDate = todaysDate
    this.datePickerToConfig.maxDate = todaysDate

    let isProof = (this.proof == 'approved') ? false : true;

    //fetching the batchOptions only if we need the batch select input
    if(this.$route.query.batch) {
      this.multiBatchSearch = false
    } else {
      this.multiBatchSearch = true
      this.$store.dispatch('documentsStore/getBatchOptions', { isProof: isProof})
    }

    //fetching the document types
    if (this.$route.query.tasksheet && ['newsnet', 'newsnettest'].includes(this.clientName)) {
      this.$store.dispatch('documentsStore/getDocumentTypes', {taskSheet: true, isProof: isProof})
    } else {
      this.$store.dispatch('documentsStore/getDocumentTypes', {taskSheet: false, isProof: isProof})
    }

    //look for client specific extra search filters
    this.$store.dispatch('documentsStore/getClientSpecificFilters', {view: 'documents'})

    //multiple doc search setup
    if(['vfne', 'vfnetest'].includes(this.clientName)) {
      this.multipleDocSearch.label = 'searchLabelMultipleDocNumsAre';
      this.multipleDocSearch.popTitle = 'popTitleMultiNum';
      this.multipleDocSearch.popDef = 'popDefMultiNum';
      this.multipleDocSearch.exactSearch = true;

      this.docSearch.label = 'searchLabelDocNum';
      this.docSearch.popTitle = 'popTitleDocNum';
      this.docSearch.popDef = 'popDefDocNum';
    }
  },
  filters: {
  },
  components: {
    datePicker
  }
}
</script>

<style scoped>

.custom-select-overflow {
  overflow-x:auto;
}

</style>
